<template>
  <div class="modal fade" id="followus" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" id="myModalLabel1">
        <div class="modal-header">
              <h4 class="modal-title">我要招聘</h4>
          </div>
        <div class="modal-body">
          <!-- Tab panels -->
          <div class="tab-content">
            <!-- Employer Panel 1-->
            <div class="tab-pane fade in show active" id="employer" role="tabpanel">
              <div class="row mrg-bot-20">
                <div class="col-md-6">
                  <p>申请免费发布账号， 请注册</p>
                </div>
                <div class="col-md-6">
                  <p>已有账号，请登录</p>
                  
                </div>
                
              </div>
              
              <div class="log-option"></div>
              
              <div class="row mrg-bot-20">
                <div class="col-md-6">
                  <a href="https://www.accacnjobs.com/#/register.html" class="btn theme-btn-outlined btn-m mrg-5" taget="_blank">雇主注册</a>
                </div>
                <div class="col-md-6">
                  <a href="https://login.accacnjobs.com" class="btn theme-btn-outlined btn-m mrg-5" taget="_blank">雇主登录</a>
                </div>
                
              </div>
        
            </div>
            <!--/.Panel 1-->
          </div>
          <!-- Tab panels -->
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
export default {
  name: 'FollowModal'
}
</script>
